import React from 'react';
import Tile from './Tile';
import { useGame } from '../../hooks/useGame';
import './Game.css';

const Game: React.FC = () => {
    const { grid, score, gameOver, won, initializeGame } = useGame();

    return (
        <div className="game-container">
            <div className="game-header">
                <div className="scores-container">
                    <div className="score-box">
                        <div className="score-label">SCORE</div>
                        <div className="score-value">{score}</div>
                    </div>
                </div>
                <button className="new-game-button" onClick={initializeGame}>
                    New Game
                </button>
            </div>

            <div className="game-board">
                {grid.map((row, rowIndex) => (
                    <div key={rowIndex} className="grid-row">
                        {row.map((value, colIndex) => (
                            <div key={`${rowIndex}-${colIndex}`} className="grid-cell">
                                <Tile value={value} />
                            </div>
                        ))}
                    </div>
                ))}
            </div>

            {(gameOver || won) && (
                <div className="game-overlay">
                    <div className="game-message">
                        <p>{won ? 'You Won!' : 'Game Over!'}</p>
                        <button onClick={initializeGame}>Try Again</button>
                    </div>
                </div>
            )}

            <div className="game-instructions">
                <p>Use arrow keys to move tiles. When two tiles with the same number touch, they merge into one!</p>
            </div>
        </div>
    );
};

export default Game; 